import type { InferGetServerSidePropsType, NextPage } from "next";
import Head from "next/head";
import { b } from "@/b";
import { HEADER_FRAGMENT } from "@/components/Header";
import { PageLayout } from "@/components/PageLayout";
import { createSanityClient } from "@/sanity/client";
import { popupMiddleware } from "@/sanity/popup-middleware";
import { pageBySlug } from "@/sanity/queries";
import { MeetTheTeamSection } from "@/sanity/sections/MeetTheTeamSection";
import { getApolloSSRProps, useHydratedQuery } from "@/util/apollo-client";

const MeetTheTeam_Query = b.query("Nutrition", (b) => [
  //
  b.__fragment(HEADER_FRAGMENT),
]);

const SanityPage: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = (props) => {
  const { page } = props;
  const { data } = useHydratedQuery(props);

  return (
    <PageLayout data={data}>
      <Head>
        <title>{page.title ?? "Visionary Meals"}</title>
      </Head>
      {(page.content ?? []).map((section) => {
        if (section._type === "meetTheTeamSection") {
          return <MeetTheTeamSection key={section._key} data={section} />;
        }
        return null;
      })}
    </PageLayout>
  );
};

export default SanityPage;

export const getServerSideProps = popupMiddleware(async (ctx) => {
  const slug = (ctx.params?.page as Array<string> | undefined)?.join("/");

  if (!slug) {
    return { notFound: true };
  }

  const client = createSanityClient(false);
  const page = await client.fetch(pageBySlug, {
    path: `/${slug}`,
  });

  if (!page) {
    return { notFound: true };
  }

  return {
    props: {
      ...(await getApolloSSRProps(MeetTheTeam_Query.document(), {}, ctx)),
      page,
    },
  };
});
